"use client";

import React, { useEffect } from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import Load from "@/app/_components/Load/Load";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";

export interface LoadingDialogProps extends SDialogProps {
    onRefresh?: (s?:any) => void;
}

export const LoadingForceDialogFC: React.FC<LoadingDialogProps> = (props) => {
    const { fcKey, onClose,onRefresh } = props;
    const {closeDialog} = useDialogMethods(fcKey);
    useEffect(() => {
        return () => {
        };
    }, []);

    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Full"
            title=''
            isCloseHideAni={true}
        >
            <div
                // onClick={closeDialog}
                className={`center`}
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Load/>
            </div>
        </SDialogFC>
    );
};

export const showForceLoading = (call?: (open: boolean) => void) => {
    SDialogManagerFC.openDialog(LoadingForceDialogFC, {
        fcKey: SDialogManagerFC.getFCKey(LoadingForceDialogFC),
        onClose: (ok:boolean) => {
            call?.(ok);
        }
    })
};

export const hideForceLoading = () => {
    SDialogManagerFC.closeDialogFC(LoadingForceDialogFC)

}